"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CardRow;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formik = require("formik");
var Icons = _interopRequireWildcard(require("../../Icons"));
var _RadioGroupInput = _interopRequireDefault(require("../../Input/RadioGroupInput"));
var _ = require("./..");
require("./CardRow.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function CardRow(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$withCheck = _ref.withCheck,
    withCheck = _ref$withCheck === void 0 ? false : _ref$withCheck,
    _ref$withRadio = _ref.withRadio,
    withRadio = _ref$withRadio === void 0 ? false : _ref$withRadio,
    _ref$withAdd = _ref.withAdd,
    withAdd = _ref$withAdd === void 0 ? false : _ref$withAdd,
    onChangeCheck = _ref.onChangeCheck,
    onChange = _ref.onChange,
    stockCheck = _ref.check,
    _ref$withExternalChec = _ref.withExternalCheck,
    withExternalCheck = _ref$withExternalChec === void 0 ? false : _ref$withExternalChec,
    onAdd = _ref.onAdd,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$rowClassName = _ref.rowClassName,
    rowClassName = _ref$rowClassName === void 0 ? '' : _ref$rowClassName,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'right' : _ref$direction,
    _ref$RightRender = _ref.RightRender,
    RightRender = _ref$RightRender === void 0 ? null : _ref$RightRender,
    _ref$textRight = _ref.textRight,
    textRight = _ref$textRight === void 0 ? 'Agregar' : _ref$textRight,
    extendComponent = _ref.extendComponent;
  var _useState = (0, _react.useState)(stockCheck),
    _useState2 = _slicedToArray(_useState, 2),
    check = _useState2[0],
    setCheck = _useState2[1];
  var _useFormikContext = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext.setFieldValue;
  var handleChangeCheck = (0, _react.useCallback)(function () {
    setCheck(!check);
    if (onChangeCheck) {
      onChangeCheck(!check);
    }
    if (onChange) {
      onChange(!check);
    }
  }, [onChangeCheck, check, onChange]);
  (0, _react.useEffect)(function () {
    if (withRadio) {
      setFieldValue(name, stockCheck);
    }
  }, [withRadio, setFieldValue, name, stockCheck]);
  var finalCheck = withExternalCheck ? stockCheck : check;
  var helpers = {
    check: finalCheck
  };
  var checkRender = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, withCheck ? /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: "0",
    onKeyPress: handleChangeCheck,
    onClick: handleChangeCheck
  }, finalCheck ? /*#__PURE__*/_react["default"].createElement(Icons.CheckAvailable, {
    width: "1.5rem",
    height: "1.5rem"
  }) : /*#__PURE__*/_react["default"].createElement(Icons.CheckUnavailable, {
    width: "1.5rem",
    height: "1.5rem"
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " ", withAdd && /*#__PURE__*/_react["default"].createElement(_.PlusButton, {
    textRight: textRight,
    onClick: onAdd
  })));
  var radioRender = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, withRadio && /*#__PURE__*/_react["default"].createElement("div", {
    className: "CardRow__Item"
  }, /*#__PURE__*/_react["default"].createElement(_RadioGroupInput["default"], {
    labelClass: "d-flex align-items-center",
    groupClass: "col-12 d-flex justify-content-around",
    parentClass: "vehicle-radio-input",
    label: "",
    name: name,
    value: finalCheck,
    options: [{
      label: '',
      value: true
    }],
    standardError: true,
    onChange: handleChangeCheck
  })));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "CardRow ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "CardRow__Row ".concat(rowClassName)
  }, direction === 'left' && (withRadio ? radioRender : checkRender), items.map(function (_ref2) {
    var value = _ref2.value,
      bold = _ref2.bold,
      title = _ref2.title,
      id = _ref2.id;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "CardRow__Item",
      key: id
    }, title ? /*#__PURE__*/_react["default"].createElement(_.TextField, {
      noMb: true,
      title: title,
      value: value
    }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, bold ? /*#__PURE__*/_react["default"].createElement("h6", {
      className: "m-0"
    }, value) : /*#__PURE__*/_react["default"].createElement("p", {
      className: "m-0"
    }, value)));
  }), extendComponent && /*#__PURE__*/_react["default"].createElement("div", {
    className: "CardRow__Extend"
  }, extendComponent), direction === 'right' && (withRadio ? radioRender : checkRender), RightRender && /*#__PURE__*/_react["default"].createElement(RightRender, helpers)));
}
CardRow.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  withCheck: _propTypes["default"].bool,
  withRadio: _propTypes["default"].bool,
  withAdd: _propTypes["default"].bool,
  onChangeCheck: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  check: _propTypes["default"].bool,
  withExternalCheck: _propTypes["default"].bool,
  onAdd: _propTypes["default"].func,
  name: _propTypes["default"].string,
  className: _propTypes["default"].string,
  rowClassName: _propTypes["default"].string,
  direction: _propTypes["default"].string,
  textRight: _propTypes["default"].string
};